import { Component, computed, HostBinding, input } from '@angular/core';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-textarea, [panTextarea]',
  templateUrl: './pan-textarea.component.html',
  styleUrl: './pan-textarea.component.scss',
  standalone: false,
})
export class PanTextareaComponent {
  public color = input<ThemeColor>('default');
  public disabled = input<boolean>(false);

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  public classes = computed(() => {
    return ['textarea', `textarea-color-${this.color()}`, this.disabled() ? 'textarea-disabled' : ''];
  });
}
